import React from 'react';
import '../index.css';
import '../output.css';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonFab,
  IonFabButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonImg,
  IonActionSheet,
} from '@ionic/react';

import HeroThumb from "../assets/images/herothumbnail.png"; // Adjust the path if needed
import burnbank from "../assets/images/burnbank_oil_1500x800.png"; // Adjust the path if needed
import MobileHeroThumb from "../assets/images/mobileherothumbnail.png"; // Adjust the path if needed
import HeroMockup from "../assets/images/UIhero.png"; // Adjust the path if needed
import CommonwealthLogo from '../assets/images/cwealthlogowhite.png';

import { chevronDownOutline } from 'ionicons/icons';
import { useState, useEffect } from 'react';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function NewHero() {

  const [panelVisible, setPanelVisible] = useState(false);

  const [panelVisiblePlusHalf, setPanelVisiblePlusHalf] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPanelVisible(true);
    }, 1000); // 3s delay

    const timer2 = setTimeout(() => {
      setPanelVisiblePlusHalf(true);
    }, 2000); // 6s delay

    return () => clearTimeout(timer);
  }, []);


  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <section
    className="hero text-black relative overflow-hidden"
    style={{
      fontFamily: "Helvetica, sans-serif",
      minHeight: "100vh",
      width: "100vw",
      backgroundImage: `url(${burnbank})`,
      backgroundSize: "cover",
      backgroundPosition: "62% center", // better for portrait; adjust as needed
      backgroundRepeat: "no-repeat",
      backgroundColor: "#000000",
    }}
  >
    <IonGrid
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        padding: 0,
      }}
    >
      {/* LOGO */}
      <IonRow>
        <IonCol>
          <img
            src={CommonwealthLogo}
            alt="Commonwealth Logo"
            style={{
              width: "140px",
              maxWidth: "42vw",
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingTop: "20px",
              paddingBottom: "0px",
              display: "block",
            }}
          />
        </IonCol>
      </IonRow>

      {/* BOTTOM HERO COPY */}
      <IonRow style={{ marginTop: "auto" }}>
        <IonCol>
          <h1
            style={{
              fontSize: "clamp(44px, 13vw, 72px)",
              fontWeight: 500,
              color: "#FFFFFF",
              margin: 0,
              lineHeight: 0.96,
              letterSpacing: "-0.04em",
              padding: "0 20px 24px",
              maxWidth: "100%",
            }}
          >
            We&apos;re here to
            <br />
            kill banks.
          </h1>
        </IonCol>
      </IonRow>

      {/* SCROLL CUE */}
      <IonRow
        className="flex justify-center"
        style={{
          paddingBottom: "18px",
        }}
      >
        <svg
          className="scrollCue__arrow"
          width="22"
          height="22"
          viewBox="0 0 16 16"
          style={{
            display: "block",
            color: "#fff",
            mixBlendMode: "difference",
            pointerEvents: "none",
            opacity: 0.95,
          }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.74999 1.75V1H7.24999V1.75V12.4393L3.28032 8.46967L2.74999 7.93934L1.68933 9L2.21966 9.53033L7.29288 14.6036C7.68341 14.9941 8.31657 14.9941 8.7071 14.6036L13.7803 9.53033L14.3107 9L13.25 7.93934L12.7197 8.46967L8.74999 12.4393V1.75Z"
            fill="currentColor"
          />
        </svg>
      </IonRow>
    </IonGrid>
  </section>
  );

} else {
    return (
      <section
        className="hero text-black relative overflow-visible"
        style={{
          fontFamily: "Helvetica, sans-serif",
          minHeight: "100vh",
          maxWidth: "100vw",
          backgroundImage: `url(${burnbank})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          //backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#000000",
        }}
      >
        <IonGrid
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh", // use minHeight so it can grow if needed
          }}
        >
          <IonRow>
            <IonCol>
              <img
                src={CommonwealthLogo}
                alt="Commonwealth Logo"
                style={{ maxWidth: "30%", padding: "50px", paddingTop: "0px"}}
              />
            </IonCol>
          </IonRow>

          {/* BOTTOM HERO COPY */}
          <IonRow style={{ marginTop: "auto" }}>
            <IonCol>
              <h1
                style={{
                  fontSize: "120px",
                  fontWeight: 500,
                  color: "#FFFFFF",
                  margin: 0,
                  lineHeight: 1.05,
                  padding: "0 50px 50px", // optional: left + bottom padding
                }}
              >
                We're here to <br /> kill banks.
            </h1>
          </IonCol>
        </IonRow>


{/*
          <IonRow className={`flex flex-col items-center justify-center text-center p-10 transition-all duration-700 ease-out translate-y-0`}
          style={{
            opacity: panelVisible ? 0.9 : 0,
            transform: panelVisiblePlusHalf ? "translateY(0) scale(1)" : "translateY(30px) scale(0.8)",
            filter: panelVisiblePlusHalf ? "blur(0px)" : "blur(1px)",

            transition: `
              opacity 1s ease-out,
              transform 1s cubic-bezier(0.16, 1, 0.3, 1),
              filter 1s ease-out
            `,
          }}
          >
            <img
              src={HeroMockup}
              alt="UI Mockup / Expanded Mortgage (Hero Edition)"
              style={{ maxWidth: "80%", maxHeight: "80%", objectFit: "contain", borderRadius: "50px", border: "25px solid rgba(255, 255, 255, 0.5)"}}
            />
          </IonRow>

          <IonRow>
            <h1> <br /> </h1>
          </IonRow>*/}

        <IonRow className="flex justify-center">

            <svg
              className="scrollCue__arrow"
              width="8%"
              height="8%"
              viewBox="0 0 16 16"
              style={{
                display: "block",

                color: "#fff",            // white + difference = invert background
                mixBlendMode: "difference",
                pointerEvents: "none",    // optional
              }}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.74999 1.75V1H7.24999V1.75V12.4393L3.28032 8.46967L2.74999 7.93934L1.68933 9L2.21966 9.53033L7.29288 14.6036C7.68341 14.9941 8.31657 14.9941 8.7071 14.6036L13.7803 9.53033L14.3107 9L13.25 7.93934L12.7197 8.46967L8.74999 12.4393V1.75Z"
                fill="currentColor"
              />
              </svg>

          </IonRow>
        </IonGrid>
      </section>
    );
  }
}
